import { RouteObject } from 'react-router-dom';
import { routes } from '../../routes';
import CartPage from './CartPage';

export const cartRoutes: RouteObject[] = [{ path: routes.CART, element: <CartPage /> }];
